import React from 'react';

export default function LaparoscopicMyomectomy() {
  return (
    <main className="section-container py-12">
      <div className="space-y-8">
        <section>
          <h1 className="text-4xl font-bold text-brand mb-6">
            Laparoscopic Myomectomy
          </h1>
          <p className="text-lg text-neutral/70 leading-relaxed">
            Fibroids or myomas are common benign tumors in women. Almost 20% of women with infertility have fibroids. If the fibroid is more than 4 cm or is inside the lining of uterus (submucous) it can affect fertility and needs to be removed. This surgery where only fibroid is removed and uterus is conserved is called myomectomy. Traditionally myomectomy was done by open technique with a 15 cm long cut and this required hospital stay up to seven days. Open surgery is associated with more pain and there is higher infection risk. Also there is higher chances of infertility arising sue to open surgery due to formation of adhesions post surgery.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            Due to this reason, minimal access surgery or laparoscopy is the preferred way of removing fibroids. In this, fibroids up to 15 cm can be removed through a 10 mm cut inside the belly button. This requires shorter hospital stay, is less painful and there are lesser chances of infection.
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            Dr. Priya Bhave Chittawar has led the research comparing open and laparoscopic myomectomy and this concluded that laparoscopic surgery is superior to open surgery (<a href="https://onlinelibrary.wiley.com/doi/10.1002/14651858.CD004638.pub3/pdf" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
              https://onlinelibrary.wiley.com/doi/10.1002/14651858.CD004638.pub3/pdf
            </a>)
          </p>
          <p className="text-lg text-neutral/70 leading-relaxed mt-4">
            Laparoscopic fibroid surgery requires lot of skill but the results are very satisfying for the patient as well as doctor. Using techniques like hydrodissection, barbed sutures for stitching the uterus have resulted in very less blood loss and rapid recovery of the patient and improvement in fertility.
          </p>
        </section>
      </div>
    </main>
  );
}
